import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export default function CenteredCircularProgress() {
  return (
    <Box sx={{width: '100%', height: '70vh', display: 'grid', alignItems: 'center', justifyItems: 'center'}}>
      <CircularProgress size={44} thickness={4}/>
    </Box>
  );
}
